<form [formGroup]="fieldForm">
    <formly-form [form]="fieldForm" [fields]="fields" [model]="fieldModel" (modelChange)="updateData($event)"></formly-form>
</form>
